import React, { useState } from 'react';
import { IOrder } from '@/interfaces/order';
import { Button, Col, notification, Row } from 'antd';

import Title from '@/components/title';

import { useMutation } from '@tanstack/react-query';
import {
  APIProvider,
  Map,
  AdvancedMarker,
  MapCameraChangedEvent,
  Pin,
  MapMouseEvent,
} from '@vis.gl/react-google-maps';
import { IShippingAddress } from '@/interfaces/shipping-address';
import { patchUpdateShippingAddress } from '@/adapters/shipping-address';

interface IProps {
  data: IOrder;
}
const DeliveryMap = ({ data }: IProps) => {
  const oldLat = Number(data?.shippingAddress?.lat || 0) || 0;
  const oldLng = Number(data?.shippingAddress?.lng || 0) || 0;
  const [point, setPoint] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: Number(data?.orderDrivers[0]?.lat || 0),
    lng: Number(data?.orderDrivers[0]?.lng || 0),
  });
  const [center, setCenter] = useState({
    lat: Number(data?.orderDrivers[0]?.lat || oldLat || 13.5769583),
    lng: Number(data?.orderDrivers[0]?.lng || oldLng || 100.7678161),
  });

  const onMapClick = (e: MapMouseEvent) => {
    setPoint({
      lat: e.detail?.latLng?.lat || 0,
      lng: e?.detail?.latLng?.lng || 0,
    });
  };

  const mutations = useMutation({
    mutationFn: async (req: Partial<IShippingAddress>) =>
      await patchUpdateShippingAddress(req),
    mutationKey: ['update-shipping-address'],
    onSuccess: data => {
      if (data?.status != 204) {
        throw new Error();
      } else {
        notification.success({
          message: 'บันทึก Map link สำเร็จ',
        });
      }
    },
    onError: error => {
      console.log('error', error);
    },
  });

  const onUpdateShipTo = async () => {
    await mutations.mutateAsync({
      id: data?.shippingAddressId,
      lat: point?.lat.toString(),
      lng: point?.lng.toString(),
    });
  };
  return (
    <Row gutter={12} className="">
      <Col span={24}>
        <div className="border-2 border-dashed rounded-md px-3">
          <Title title="Map" />
          <div
            style={{
              height: 350,
              width: '100%',
              marginBottom: 20,
            }}
          >
            <APIProvider
              apiKey={'AIzaSyC3LUICKk1b104OLYosRFxRgOYysgSrD_o'}
              onLoad={() => console.log('Maps API has loaded.')}
            >
              <Map
                defaultZoom={12}
                defaultCenter={center}
                onClick={onMapClick}
                onCameraChanged={(ev: MapCameraChangedEvent) => {
                  setCenter(ev.detail.center);
                }}
                mapId="x12"
                center={center}
              >
                {oldLat != 0 && (
                  <AdvancedMarker position={{ lat: oldLat, lng: oldLng }}>
                    <Pin
                      background={'#FF3F33'}
                      glyphColor={'#000'}
                      borderColor={'#000'}
                    />
                  </AdvancedMarker>
                )}
                {point?.lat != 0 && (
                  <AdvancedMarker position={point} clickable={true}>
                    <Pin
                      background={'#FBBC04'}
                      glyphColor={'#000'}
                      borderColor={'#000'}
                    />
                  </AdvancedMarker>
                )}
              </Map>
            </APIProvider>
          </div>
          {(point?.lat && (
            <Button
              type="primary"
              className="mt-ๅ"
              block
              size="large"
              loading={mutations.isPending}
              onClick={() => onUpdateShipTo()}
            >
              อัพเดทโลเคชั่นใหม่สำหรับ {data?.shippingAddress?.name}
            </Button>
          )) ||
            ''}
        </div>
      </Col>
    </Row>
  );
};

export default DeliveryMap;
